"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/**
 * 股东持股明细页面
 */
require("../../src/modules/singlestocktop/web");
var utils_1 = __importDefault(require("../../src/modules/commonutil/utils"));
var datatable_1 = __importDefault(require("../../src/modules/datatable"));
var public_1 = require("./public");
var delayquote_1 = require("../../src/modules/delayquote");
var webconfig = require('../../config/web');
var ggcgbd = {
    init: function () {
        var that = this;
        this.chart_bar = echarts.init(document.getElementById('cgbd_chart'));
        this.getData(); //股东持股变动图
        var paramobj = {
            reportName: 'RPTA_WEB_GDMX',
            columns: 'ALL',
            token: '28dfeb41d35cc81d84b4664d7c23c49f',
            pageNumber: 1,
            pageNo: 1,
            pageSize: 50,
            sortColumns: 'ENDDATE',
            sortTypes: -1,
            quoteColumns: 'f2,f3',
            quoteType: delayquote_1.hsaDelay() ? "1" : "0",
            filter: "(SCODE=\"" + stockInfo.code + "\")",
        };
        this.loadTable(paramobj); //增减持股变动明细
        $('#type_radio input').change(function () {
            var data_type = $(this).data('type') || '';
            that.getData(data_type);
        });
        //增持减持切换
        $("#zj_type_ul li").click(function () {
            $("#zj_type_ul li").removeClass('at');
            $(this).addClass('at');
            var zj_type = $(this).attr('data');
            paramobj.pageNumber = 1;
            paramobj.pageNo = 1;
            paramobj.filter = "(SCODE=\"" + stockInfo.code + "\")" + zj_type;
            that.table.search(paramobj);
        });
    },
    getData: function (data_type) {
        return __awaiter(this, void 0, void 0, function () {
            var that, params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        that = this;
                        data_type = data_type || 'BDJE';
                        that.XData = [];
                        that.YData = [];
                        params = {
                            reportName: 'RPTA_WEB_GDGGTJ',
                            columns: 'ALL',
                            token: '28dfeb41d35cc81d84b4664d7c23c49f',
                            pageNumber: 1,
                            pageSize: 500,
                            sortColumns: 'TDATE',
                            sortTypes: 1,
                            filter: "(SCODE=\"" + stockInfo.code + "\")"
                        };
                        return [4 /*yield*/, $.ajax({
                                url: webconfig.getWebPath('datacenter') + "api/data/v1/get",
                                dataType: "jsonp",
                                data: params
                            }).then(function (data) {
                                that.chart_bar.showLoading({
                                    text: '图表加载中...' //loading
                                });
                                if (data.result && data.result.data) {
                                    var chartData = data.result.data;
                                    var data1 = [], data2 = [];
                                    for (var i = 0; i < chartData.length; i++) {
                                        var item = chartData[i];
                                        if (data_type == "BDJE") {
                                            data1.push(utils_1["default"].toFixed2(Math.abs(item.ZCJE) || '')); //为0时置空
                                            data2.push(utils_1["default"].toFixed2(Math.abs(item.JCJE) || ''));
                                        }
                                        else {
                                            data1.push(utils_1["default"].toFixed2(Math.abs(item.ZCSL) || ''));
                                            data2.push(utils_1["default"].toFixed2(Math.abs(item.JCSL) || '', 2));
                                        }
                                        that.XData.push(utils_1["default"].getTextValOrEmpty(item.TDATE));
                                    }
                                    that.YData.push(data1);
                                    that.YData.push(data2);
                                }
                                that.loadChart(); //调用画图方法
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    loadChart: function () {
        var that = this;
        var dw_name = $('#type_radio input:checked').next("label").data("name") || '元';
        // 指定图表的配置项和数据
        var option = {
            tooltip: {
                trigger: 'axis'
            },
            legend: {
            //data: ['销量']
            },
            xAxis: {
                data: that.XData,
                axisTick: { show: false },
                splitLine: {
                    show: false
                },
                axisLabel: {
                    textStyle: {
                        color: '#000'
                    }
                }
            },
            yAxis: {
                name: '单位：' + dw_name,
                axisTick: { show: false },
                splitLine: {
                    show: true,
                    lineStyle: {
                        type: 'dotted',
                        color: "#E6E6E6"
                    }
                },
                axisLabel: {
                    textStyle: {
                        color: '#000'
                    }
                    //formatter: function (value, index) {
                    //    return Tools.toFixed(value / 10000);
                    //}
                }
            },
            series: [{
                    name: "增持",
                    type: 'bar',
                    barGap: 0,
                    color: '#d32f2f',
                    barMaxWidth: '30',
                    barMinHeight: 1,
                    data: that.YData[0]
                },
                {
                    name: "减持",
                    type: 'bar',
                    color: '#4caf50',
                    barMaxWidth: '30',
                    barMinHeight: 1,
                    data: that.YData[1]
                }]
        };
        // 使用刚指定的配置项和数据显示图表。
        that.chart_bar.setOption(option);
        that.chart_bar.hideLoading();
    },
    loadTable: function (paramobj) {
        var that = this;
        that.table = new datatable_1["default"]({
            table_type: 'bdmx_table',
            div_id: 'bdmx_table',
            pager_id: 'bdmx_table_pager',
            enabled_pager: true,
            floathead: true,
            loadscroll: true,
            loadingImg: true,
            dataurl: {
                hostname: 'datacenter',
                url: 'api/data/v1/get',
                params: paramobj
            },
            columns: {
                theadfix: {
                    bdxx: function (v) {
                        return '持股变动信息';
                    },
                    cgqk: function (v) {
                        return '变动后持股情况';
                    }
                },
                config: [
                    {
                        // width: 55,
                        paramname: 'NDATE',
                        sort: public_1.setSortObj('NDATE'),
                        th: function name(v) {
                            return '公告日期';
                        },
                        td: function (v) {
                            return utils_1["default"].dateFormat(v.NDATE);
                        }
                    },
                    {
                        width: 38,
                        paramname: '',
                        th: function name(v) {
                            return '相关';
                        },
                        td: function (v) {
                            var notice_url = "/notices/stock/" + v.SCODE + ".html";
                            return '<a href=' + notice_url + '>公告</a>';
                        }
                    },
                    {
                        width: 50,
                        paramname: '',
                        th: function name(v) {
                            return '当日<br/>收盘价';
                        },
                        td: function (v) {
                            return '<span class="' + utils_1["default"].getColor(v.CHG) + '">' + utils_1["default"].toFixed2(v.SPJ) + '</span>'; //当日收盘价 
                        }
                    },
                    {
                        width: 78,
                        paramname: '',
                        th: function name(v) {
                            return '股东名称';
                        },
                        td: function (v) {
                            return "<a title='" + v.GDMC + "' style='cursor: pointer;' href='/executive/gdzjc.html?name=" + encodeURIComponent(v.GDMC) + "'>" + utils_1["default"].txtLeft(v.GDMC, 8, true) + "</a>";
                        }
                    },
                    {
                        theadfix: 'bdxx',
                        width: 38,
                        paramname: '',
                        th: function name(v) {
                            return '变动方向';
                        },
                        td: function (v) {
                            return '<span class="' + (v.BDFX == "增持" ? "red" : "green") + '">' + v.BDFX + '<span>';
                        }
                    },
                    {
                        theadfix: 'bdxx',
                        width: 53,
                        paramname: 'BDGS',
                        sort: public_1.setSortObj('BDGS'),
                        th: function name(v) {
                            return "\u53D8\u52A8\u6570\u91CF(\u80A1)";
                        },
                        td: function (v) {
                            return utils_1["default"].numFormat(v.BDGS * 10000);
                        }
                    },
                    {
                        theadfix: 'bdxx',
                        width: 48,
                        paramname: 'CGBDZZGBBL',
                        sort: public_1.setSortObj('CGBDZZGBBL'),
                        th: function name(v) {
                            return "\u5360\u603B\u80A1\u672C\u6BD4\u4F8B\uFF08%\uFF09";
                        },
                        td: function (v) {
                            return utils_1["default"].numFormat(v.CGBDZZGBBL * 100);
                        }
                    },
                    {
                        theadfix: 'bdxx',
                        width: 51,
                        paramname: 'CGBDZLTGBL',
                        sort: public_1.setSortObj('CGBDZLTGBL'),
                        th: function name(v) {
                            return '占流通股比例(%)<i class="icon icon_faq" title="占流通股比例=持流通股数/流通A股(或B股)"></i>';
                        },
                        td: function (v) {
                            return utils_1["default"].numFormat(v.CGBDZLTGBL);
                        }
                    },
                    {
                        theadfix: 'cgqk',
                        width: 52,
                        paramname: 'BDHCGZS',
                        sort: public_1.setSortObj('BDHCGZS'),
                        th: function name(v) {
                            return "\u6301\u80A1\u603B\u6570(\u80A1)";
                        },
                        td: function (v) {
                            return utils_1["default"].numFormat(v.BDHCGZS * 10000);
                        }
                    },
                    {
                        theadfix: 'cgqk',
                        width: 52,
                        paramname: 'BDHZZGBBL',
                        sort: public_1.setSortObj('BDHZZGBBL'),
                        th: function name(v) {
                            return "\u5360\u603B\u80A1\u672C\u6BD4\u4F8B\uFF08%\uFF09";
                        },
                        td: function (v) {
                            return utils_1["default"].numFormat(v.BDHZZGBBL);
                        }
                    },
                    {
                        theadfix: 'cgqk',
                        width: 52,
                        paramname: 'BDHCLTGZS',
                        sort: public_1.setSortObj('BDHCLTGZS'),
                        th: function name(v) {
                            return "\u6301\u6D41\u901A\u80A1\u6570(\u80A1)";
                        },
                        td: function (v) {
                            return utils_1["default"].numFormat(v.BDHCLTGZS * 10000);
                        }
                    },
                    {
                        theadfix: 'cgqk',
                        width: 52,
                        paramname: 'BDHZLTGBL',
                        sort: public_1.setSortObj('BDHZLTGBL'),
                        th: function name(v) {
                            return '占流通股比例(%)<i class="icon icon_faq" title="占流通股比例=持流通股数/流通A股(或B股)"></i>';
                        },
                        td: function (v) {
                            return utils_1["default"].numFormat(v.BDHZLTGBL);
                        }
                    },
                    {
                        width: 50,
                        paramname: 'STARTDATE',
                        sort: public_1.setSortObj('STARTDATE'),
                        th: function name(v) {
                            return "\u53D8\u52A8<br/>\u5F00\u59CB\u65E5";
                        },
                        td: function (v) {
                            return utils_1["default"].dateFormat(v.STARTDATE, "MM-DD");
                        }
                    },
                    {
                        width: 50,
                        paramname: 'ENDDATE',
                        sort: public_1.setSortObj('ENDDATE'),
                        defaultsortType: 'desc',
                        th: function name(v) {
                            return "\u53D8\u52A8<br/>\u622A\u6B62\u65E5";
                        },
                        td: function (v) {
                            return utils_1["default"].dateFormat(v.ENDDATE, "MM-DD");
                        }
                    }
                ]
            }
        });
    }
};
$(function () {
    ggcgbd.init();
});
